import { SVGProps, Ref, forwardRef } from 'react';

export const MaxSquareGrayscaleSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <rect x={1} y={1} width={22} height={22} rx={4.58} fill="#919191" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.158 19.291c-1.447 0-2.12-.21-3.288-1.055-.74.95-3.08 1.692-3.183.422 0-.953-.21-1.758-.45-2.638-.285-1.083-.61-2.29-.61-4.037 0-4.175 3.43-7.316 7.493-7.316 4.066 0 7.252 3.295 7.252 7.354a7.24 7.24 0 0 1-2.102 5.126 7.26 7.26 0 0 1-5.112 2.144m.06-11.016c-1.978-.102-3.52 1.267-3.862 3.412-.282 1.776.218 3.94.644 4.052.205.05.719-.366 1.039-.686.53.366 1.147.585 1.788.637a3.77 3.77 0 0 0 3.94-3.507 3.76 3.76 0 0 0-3.549-3.904z"
                fill="#E2E2E2"
            />
        </g>
    </svg>
));
MaxSquareGrayscaleSize24Glyph.displayName = 'MaxSquareGrayscaleSize24Glyph';
